/**
 * Limites et quotas transverses.
 * Référence : document 06 § 2.6 (pagination) et § 10 (sécurité de l'API).
 */
export const PAGINATION_DEFAULT_PAGE = 1;
export const PAGINATION_DEFAULT_PAGE_SIZE = 25;
export const PAGINATION_MAX_PAGE_SIZE = 100;
export const SORT_DIRECTION_DESC_PREFIX = '-';
export const SORT_FIELDS_SEPARATOR = ',';
export const FILTER_VALUES_SEPARATOR = ',';
export const FILTER_OPERATORS = ['eq', 'ne', 'gt', 'gte', 'lt', 'lte', 'in'];
/** Longueurs maximales de quelques champs d'entrée exposés. */
export const MAX_EMAIL_LENGTH = 190;
export const MAX_PASSWORD_LENGTH = 128;
export const MIN_PASSWORD_LENGTH = 12;
/** Taille maximale du corps JSON accepté par l'API (hors téléversements GED). */
export const JSON_BODY_LIMIT = '1mb';
/** Second facteur TOTP (document 06 § 3.1). */
export const MFA_CODE_LENGTH = 6;
export const MFA_BACKUP_CODE_COUNT = 10;
export const RATE_LIMIT_DEFAULT_WINDOW_MS = 60_000;
export const RATE_LIMIT_DEFAULT_MAX_REQUESTS = 300;
/** Quota renforcé sur les routes d'authentification (anti-bruteforce). */
export const RATE_LIMIT_AUTH_MAX_REQUESTS = 20;
export const RATE_LIMIT_AUTH_WINDOW_MS = 15 * 60_000;
//# sourceMappingURL=limits.constants.js.map